import type { StyleLayer } from './utils/types'

export const layers_parkingLars_stats_length: StyleLayer[] = [
  {
    id: 'area-0-to-100 copy',
    type: 'fill',
    filter: ['has', 'lane_km'],
    paint: {
      'fill-color': [
        'interpolate',
        ['linear'],
        ['to-number', ['get', 'lane_km']],
        0,
        'rgb(163, 255, 189)',
        200,
        'rgb(0, 128, 36)',
      ],
      'fill-opacity': 0.35,
      'fill-outline-color': 'hsl(0, 100%, 100%)',
    },
  },
  {
    id: 'line copy',
    type: 'line',
    filter: ['has', 'lane_km'],
    paint: {
      'line-color': 'hsl(0, 0%, 100%)',
      'line-opacity': 0.63,
    },
  },
  {
    id: 'label copy',
    type: 'symbol',
    filter: ['has', 'lane_km'],
    layout: {
      'text-field': ['to-string', ['get', 'lane_km']],
    },
    paint: {
      'text-color': 'rgba(0, 51, 37, 0.95)',
      'text-halo-blur': 1,
      'text-halo-color': 'hsl(291, 0%, 100%)',
      'text-halo-width': 1,
    },
  },
]
